<div class="d-flex flex-row align-items-center mb-3 ml-3 mr-3">
  <div class="h3">{{ 'profile_details_header' | i18next }}</div>
  @if (mode === 'multiprofile') {
    <div class="ml-auto bd-highlight">
      <button class="btn btn-outline-primary" (click)="addProfile()">{{ 'profile_add_new' | i18next }}</button>
    </div>
  }
</div>
<app-partnership-navigation [isCSP]="isCSP"></app-partnership-navigation>
<i class="fa fa-info-circle mb-3 red"></i><span class="ml-2">{{ 'profile_hint' | i18next}}</span>
@if (mode === 'enabled') {
  <div>
    <app-profile-details [profile]="firstProfile"></app-profile-details>
  </div>
}
@if (mode === 'multiprofile') {
  <div class="row">
    @for (p of profiles; track p) {
      <app-profile-card class="col-xs-12 col-md-6" [profile]="p"></app-profile-card>
    }
  </div>
}
